import React from "react";
import { Drawer } from "antd";

import DrawerTitle from "./DrawerTitle";

const DrawerForm = ({ title, subtitle, visible, onClose, children }) => {
    return (
        <Drawer
            title={<DrawerTitle title={title} subtitle={subtitle} />}
            className="drawer-add-cursos"
            width={720}
            onClose={onClose}
            visible={visible}
            maskClosable={false}
            destroyOnClose
        >
            {children}
        </Drawer>
    );
};

export default DrawerForm;
